// Source-agnostic on purpose: copy that names the agent's sources goes stale the
// moment it gains one, and every workspace on the default has to be migrated.
export const defaultAiChatWelcomeMessage = (
	workspaceName?: string | null,
): string =>
	`Hi! I'm an AI agent. Ask me anything about ${workspaceName?.trim() || "the product"}. I can also file an engineering ticket when you hit a bug.`

// Names no specific tag, since it runs on every workspace. Workspaces seeded
// before the default grew still hold this line alone.
export const ROUTINE_TAG_LINE =
	"Apply a tag that matches what the thread is about."

export const ROUTINE_CLOSE_THANKS_LINE =
	"Mark the thread done when a reply is only thanks."

export const ROUTINE_SUMMARIZE_LINE =
	"Summarize threads over 300 words in a note."

// Seeded into every new workspace: the lines customers most often add themselves.
export const ROUTINE_DEFAULT_PROMPT = [
	ROUTINE_TAG_LINE,
	ROUTINE_CLOSE_THANKS_LINE,
	ROUTINE_SUMMARIZE_LINE,
].join("\n")

// Product-agnostic on purpose: a new workspace has no docs, roadmap or changelog
// yet, so a starter that assumes one gives the visitor an empty answer.
export const defaultAiChatExampleQuestions = [
	"How does pricing work?",
	"How do I report a bug?",
	"Can I talk to a human?",
] as const
